














































































































import { activitySessionfilters } from '@/config/activities';
import { BasicCalendarEvent } from '@bookings/interfaces/calendar';
import { ApiRouteType } from '@core/interfaces/core-services';
import WeeklyCalendar from '@shared/components/calendars/weekly-calendar.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import { CalendarHelper } from '@shared/helpers/calendar-helper';
import { isNull } from 'lodash';
import moment from 'moment';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import SessionCalendarItem from './session-calendar-item.vue';
@Component({
  name: 'bpc-sessions-weekly-calendar',
  components: {
    'bpc-weekly-calendar': WeeklyCalendar,
    'bpc-date-picker': Datepicker,
    'bpc-entity-select': EntitySelect,
    'bpc-multi-select': MultiSelect,
    'bpc-session-calendar-item': SessionCalendarItem,
  },
})
export default class SessionsWeeklyCalendar extends Vue {
  // PROPS
  @Prop({ type: Boolean }) readonly showActivityFilter: boolean;
  @Prop({ type: Boolean }) readonly showTeamFilter: boolean;
  @Prop({ type: Boolean }) readonly xsSlot: boolean;
  @Prop({ type: Boolean }) readonly showStatusFilter: boolean;
  @Prop({ type: Boolean }) readonly withUrlParams: boolean;
  @Prop({ type: Boolean }) readonly publicApi: boolean;
  @Prop({ type: Boolean }) readonly disableEdit: boolean;
  @Prop({ type: Boolean }) readonly disableSelect: boolean;
  @Prop({ type: Boolean }) readonly disableChangeView: boolean;
  @Prop({ type: Object }) readonly initialFilters: {
    activity_id: number;
    responsible_ids: number[];
    team_id: number[];
    status: string;
    to_date: string;
  };
  // @Prop({ type: String, default: '' }) readonly myStrProp: string;
  // @Prop({ type: Object, default() {return {};}}) readonly myObjectProp: MyInterface;
  // DATA
  calendarItems: BasicCalendarEvent[] = [];
  loading: boolean = false;
  selectedDate: string = null;
  urlParams: Record<string, string> = {};
  selectedActivities = [];
  selectedResponsibles = [];
  selectedTeam = null;
  selectedStatus = null;
  sendEmailOptionSelected: boolean = this.defaultSendBookingEventChangeEmail;
  calendarEvent = null;
  // LIFECYCLE

  mounted() {
    this.initializeFiltersFromProperties();
    this.initializeValuesFromUrlParams();
    this.getSessionsIfStopChanging();
  }
  // updated(){}
  // destroyed(){}
  // COMPUTED
  get filtersConfig() {
    return activitySessionfilters;
  }
  get weekStartDate(): string {
    return this.selectedDate
      ? moment(this.selectedDate)
          .startOf('isoWeek')
          .format('YYYY-MM-DD')
      : null;
  }

  get weekEndDate(): string {
    return this.selectedDate
      ? moment(this.selectedDate)
          .endOf('isoWeek')
          .format('YYYY-MM-DD')
      : null;
  }

  get changeDetectorStr(): string {
    return [
      this.weekStartDate,
      this.weekEndDate,
      ...this.selectedActivities,
      ...this.selectedResponsibles,
      this.selectedTeam,
      this.selectedStatus,
    ].join('--');
  }

  get defaultSendBookingEventChangeEmail(): boolean {
    return !!this.$store.getters['centerSettings/centerSettings']?.admin_send_session_updated_email;
  }

  get showSendEmailOption(): boolean {
    return this.$store.getters['centerSettings/centerSettings']?.send_session_updated_email;
  }

  public get confirmationUpdateModalTitle() {
    return this.$t('global.modals.update-session.title');
  }

  public get confirmButtonText() {
    return this.$t('global.buttons.confirm');
  }

  public get cancelButtonText() {
    return this.$t('global.buttons.cancel');
  }

  public get sendEmailOptionsLabel() {
    return this.$t('global.modals.update-booking-event.send_email.label');
  }

  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }

  get filtersToApplyInTheTeamSelector() {
    const filters = [{ filterField: 'type', value: 'team' }];
    if (this.tenantType === 'club') {
      filters.push({ filterField: 'status', value: 'active' });
    }
    return filters;
  }

  // METHODS
  getPopoverContentStr(info) {
    const extendedProps = info.event.extendedProps;
    let contentHtml = `<b class="event-time">${info.timeText}</b>`;
    if (extendedProps.responsibles && extendedProps.responsibles.length) {
      extendedProps.responsibles.forEach(responsible => {
        contentHtml += `<div class="event-responsible">${responsible.fullname}</div>`;
      });
    }
    contentHtml += `
      <div class="event-num-of-attendees">
        ${this.$t('activities.num_of_attendees_short')}:
        <span class="number-of-attendees">
          ${extendedProps.number_of_attendees}
        </span>`;
    if (extendedProps.max_participants) {
      contentHtml += `<span class="max-participants">
          / ${extendedProps.max_participants}
        </span>`;
    } else {
      contentHtml += `<span class="max-participants max-participants--unlimited">
          / ${this.$t('activities.max_participants_unlimited')}
        </span>`;
    }

    contentHtml += `</div>`;

    return contentHtml;
  }

  changeViewCliked(e) {
    this.$emit('change-view-clicked', e);
  }

  onSessionClicked(e) {
    this.$emit('session-clicked', e.event);
  }

  onDateSelected(e) {
    this.$emit('date-selected', {
      date: moment(e.start).format('YYYY-MM-DD'),
      time_range: {
        start_time: moment(e.start).format('HH:mm'),
        end_time: moment(e.end).format('HH:mm'),
      },
    });
  }

  async onSessionDateTimeChange(e) {
    this.calendarEvent = e;
    if (this.showSendEmailOption) {
      this.$bvModal.show(`confirmation-update-modal-session-from-calendar`);
    } else {
      this.confirmUpdateEvent();
    }
  }

  async confirmUpdateEvent() {
    const baseUrl = this.$bpcApiRouteHelper.getEntityPath('activity-sessions');
    const url = `${baseUrl}/${this.calendarEvent.event.id}/change-datetime`;
    try {
      await this.$bpcApi
        .put(url, {
          start_date_time: moment(this.calendarEvent.event.start).format('YYYY-MM-DD HH:mm'),
          end_date_time: moment(this.calendarEvent.event.end).format('YYYY-MM-DD HH:mm'),
          notify_by_email: this.showSendEmailOption ? this.sendEmailOptionSelected : false,
        })
        .toPromise();
    } catch (error) {
      this.$bpcMessage.showErrorMessage({ text: 'activities.error_changing_session_datetime' });
    }
    this.getAllSessionsOfTheWeek();
  }

  async getAllSessionsOfTheWeek() {
    this.loading = true;
    const params = this.getQueryParams();
    const apiType: ApiRouteType = this.publicApi ? 'public' : 'admin';

    const url = this.$bpcApiRouteHelper.getEntityPath('activity-sessions');
    const res = await this.$bpcApi.get(url, { params: params }, apiType).toPromise();
    this.calendarItems = CalendarHelper.fromActivitySessionsToCalendarEvents(res.data);
    this.$emit('query-params-changed', params);
    this.loading = false;
  }

  getSessionsIfStopChanging() {
    const changeStr = this.changeDetectorStr;
    setTimeout(() => {
      if (changeStr === this.changeDetectorStr) {
        this.getAllSessionsOfTheWeek();
      }
    }, 300);
  }

  getQueryParams() {
    const params = {
      orderBy: 'start_date_time',
      orderDirection: 'asc',
      per_page: -1,
      activity_id: this.selectedActivities,
      status: this.selectedStatus,
      responsible_ids: this.selectedResponsibles,
      team_id: this.selectedTeam,
      from_date: this.weekStartDate,
      to_date: this.weekEndDate,
      with_attendees_count: true,
    };

    /* NOTE: if the tenant is a club we need to show only the session of the active groups teams. */
    if (this.tenantType === 'club') {
      params['team_group_status'] = 'active';
    }

    return params;
  }

  initializeValuesFromUrlParams() {
    if (this.withUrlParams) {
      const urlParams = this.getUrlParams();
      this.selectedDate = urlParams?.to_date || moment().format('YYYY-MM-DD');
      this.selectedStatus = urlParams?.status || 'active';
      if (urlParams?.activity_id) {
        if (Array.isArray(urlParams?.activity_id)) {
          this.selectedActivities = urlParams?.activity_id;
        } else {
          this.selectedActivities = [urlParams?.activity_id];
        }
      } else if (!this.initialFilters?.activity_id) {
        // Set empty if there is no set anytime
        this.selectedActivities = [];
      }

      if (urlParams?.responsibles) {
        if (Array.isArray(urlParams?.responsible_ids)) {
          this.selectedResponsibles = urlParams?.responsible_ids;
        } else {
          this.selectedResponsibles = [urlParams?.responsible_ids];
        }
      } else {
        this.selectedResponsibles = [];
      }

      if (urlParams?.team_id) {
        this.selectedTeam = urlParams?.team_id;
      } else {
        this.selectedTeam = null;
      }
    }
  }

  initializeFiltersFromProperties() {
    if (this.initialFilters) {
      this.selectedDate = this.initialFilters?.to_date || moment().format('YYYY-MM-DD');
      this.selectedStatus = this.initialFilters?.status || 'active';
      if (this.initialFilters?.activity_id) {
        if (Array.isArray(this.initialFilters?.activity_id)) {
          this.selectedActivities = this.initialFilters?.activity_id;
        } else {
          this.selectedActivities = [this.initialFilters?.activity_id];
        }
      } else {
        this.selectedActivities = [];
      }

      if (this.initialFilters?.responsible_ids) {
        if (Array.isArray(this.initialFilters?.responsible_ids)) {
          this.selectedResponsibles = this.initialFilters?.responsible_ids;
        } else {
          this.selectedResponsibles = [this.initialFilters?.responsible_ids];
        }
      } else {
        this.selectedResponsibles = [];
      }

      if (this.initialFilters?.team_id) {
        this.selectedTeam = this.initialFilters?.team_id;
      } else {
        this.selectedTeam = null;
      }
    }
  }

  getUrlParams() {
    const urlQueryParams = JSON.parse(JSON.stringify(this.$route.query), (k, v) => {
      if (!isNaN(v) && !isNull(v)) {
        return parseInt(v);
      }
      return v;
    });
    return {
      ...urlQueryParams,
    };
  }

  // WATCHERS
  @Watch('changeDetectorStr')
  onChangeDetectorStrChange(val) {
    if (val) {
      this.getSessionsIfStopChanging();
    }
  }
}
